import WistiaHelper from '../../../common/gdpr/wistia-helper';
import WG from '../../../common/modules/wg';
(function() {
    /* global */
    'use strict';

    function QuoteWidget() {
        $('.js-video-play').on('click', function() {
            WG.GdprUserCentrics.makeConditionalCallback(() => {
                var $playBtn = $(this);
                var wistiaId = $playBtn.data('wistia-id') || false;
                var youtubeId = $playBtn.data('youtube-id') || false;

                this.appendWistiaVideo = WistiaHelper.appendWistiaVideo || function() {};

                if (youtubeId) {
                    $playBtn.append(
                        '<iframe src="https://www.youtube.com/embed/' +
                            $playBtn.data('youtube-id') +
                            '/?autoplay=true" frameborder="0" allowfullscreen></iframe>'
                    );
                } else if (wistiaId) {
                    if ($playBtn.hasClass('playing')) {
                        return false;
                    }
                    this.appendWistiaVideo($playBtn, wistiaId);
                    $playBtn.addClass('playing');
                }
            }, WG.GdprUserCentrics.ConsentCategories.Advertising)();
        });
    }

    window.apps = window.apps || {};
    window.apps.QuoteWidget = QuoteWidget;
})();



// WEBPACK FOOTER //
// ./assets/js/projects/apps/widgets/quote.js